<template>
    <div>
        <div class="bg-icon">
            <img src="../../assets/forget_password_logo.png" alt="">
        </div>

        <div id="forget-password-form-info">
            <div>
                <div class="info">
                    <input class="input" type="text" name="forgetPasswordUsername"
                           placeholder="输入 会员名/会员编号/手机号"
                           v-model="forgetPasswordForm.memberUsername">
                </div>

                <button class="search-member" @click="forgetPasswordMemberSearch" :disabled="btnDisable">
                    查询
                </button>
            </div>

            <div style="clear:both;"></div>

            <!--验证密码-->
            <div id="mobile-verify" v-show="showMobileVerify">
                <div>
                    <div class="info">
                        <input class="input" type="text" name="forgetPasswordUsername" disabled="disabled"
                               v-model="forgetPasswordForm.tel">
                    </div>

                    <button v-if="isCaptcha" class="search-member" @click="sendCaptcha">
                        发送
                    </button>
                    <button v-if="!isCaptcha" class="search-member rest" >
                        {{ count }}s
                    </button>
                </div>

                <div style="clear:both;"></div>

                <div>
                    <div class="info">
                        <input class="input" type="text" name="forgetPasswordUsername"
                               placeholder="请输入验证码"
                               v-model="forgetPasswordForm.verifyCode" :maxlength="4" @input="inputChange">
                    </div>

                    <button class="search-member" :class="{'rest': !sendDisable}"  @click="checkCaptcha">
                        验证
                    </button>
                </div>

                <div style="clear:both;"></div>
            </div>

            <!--设定密码-->
            <div id="input-password" v-show="showSettingPassword">
                <div>
                    <div class="password">
                        <input class="input" type="password" name="forgetPasswordUsername"
                               placeholder="请输入新密码"
                               v-model="forgetPasswordForm.password" :maxlength="20">
                    </div>
                </div>

                <div>
                    <div class="password">
                        <input class="input" type="password" name="forgetPasswordUsername"
                               placeholder="请确认新密码"
                               v-model="forgetPasswordForm.confirmPassword" :maxlength="20">
                    </div>
                </div>

            </div>
        </div>
        
        <div style="clear:both;"></div>

        <div class="forget-password-member-service-info" style="margin-top: 5px">
            <span style="font-size: 14px; color: #ed3f14; margin-top: 20px; font-weight: bold" @click="callPhone">
                免费服务热线：800 8308960 <br>
            </span>
            <p style="font-size: 12px; color: #ed3f14;">
                *热线服务时间：周一至周五08:30-17:30 <br>
                (国家法定假日和公司假期除外)
            </p>
        </div>

        <base-dialog v-show="messageVisible" :title="title" width="80%" @close="close">
            <p>{{ message }}</p>
        </base-dialog>

        <div class="toast" v-show="toastShow">
            {{toastText}}
        </div>

        <div id="forget-password-member-submit" v-show="showSettingPassword">
            <div class="submit-btn" @click="resetPassword">提交</div>
        </div>
    </div>
</template>

<script>
    import BaseDialog from "../../components/BaseDialog";
    import { SearchMember, SendCaptcha, ResetPassword, SearchOrder } from "../../api/Login";
    import md5 from 'js-md5'
    import {starPhone} from "@/unitls";
    import {PASSWORD_MOBILE} from "@/config/app";

    export default {
        name: "ForgetPassword",

        components: {
            BaseDialog
        },

        data() {
            return {
                forgetPasswordForm: {
                    memberId: '',
                    memberUsername: '',
                    mobile: '',
                    verifyCode: '',
                    password: '',
                    confirmPassword: '',
                    tel: '',
                },

                toastShow: false,
                toastText: '',

                title: '提示',
                messageVisible: false,
                message: "",

                showMobileVerify: false,
                showSettingPassword: false,

                isEdit: false,
                isCaptcha: true,
                timer: null,
                count: '', //发送验证码倒计时

                btnDisable: false,
                sendDisable: false,


            }
        },

        methods: {

            close() {
                this.messageVisible = false;
                this.$emit('close');
            },

            toast (e) {
                let _that = this;
                this.toastText = e;
                this.toastShow = true;
                setTimeout(function(){
                    _that.toastShow = false;
                    if (_that.isEdit) {
                        _that.$router.go(-1);
                    }

                }, 1500)
            },

            forgetPasswordMemberSearch() {
                if (this.forgetPasswordForm.memberUsername === '') {
                    this.toast("输入 会员名/会员编号/手机号");
                    return
                }

                this.searchMember()
            },

            //查询账户
            searchMember() {
                this.btnDisable = true;
                SearchMember(this.forgetPasswordForm.memberUsername)
                    .then((response) => {
                    if (this.$API_CODE.OK === response.code) {
                        this.forgetPasswordForm.tel = starPhone(response.data.mobile);
                        this.forgetPasswordForm.mobile = response.data.mobile;
                        this.forgetPasswordForm.memberId = response.data.memberId;
                        if (this.forgetPasswordForm.mobile !== '') {
                            this.showMobileVerify = true
                        } else {
                            this.showSettingPassword = false;
                            this.searchOrder(response.data.id)
                        }
                    } else {
                        this.messageVisible = true;
                        this.message = response.message;
                    }
                    this.btnDisable = false;
                })
            },

            //获取验证码
            sendCaptcha() {
                if (this.isCaptcha) {
                    this.btnDisable = true;
                    SendCaptcha(this.forgetPasswordForm.mobile).then((response) => {
                        if (this.$API_CODE.OK === response.code) {
                            this.toast("验证码已发送");

                            const TIME_COUNT = 60;
                            if (!this.timer) {
                                this.count = TIME_COUNT;
                                this.isCaptcha = false;
                                this.timer = setInterval(() => {
                                    if (this.count > 0 && this.count <= TIME_COUNT) {
                                        this.count--;
                                    } else {
                                        this.isCaptcha = true;
                                        clearInterval(this.timer);
                                        this.timer = null;
                                    }
                                }, 1000);
                            }
                        } else {
                            this.messageVisible = true;
                            this.message = response.message;
                        }
                        this.btnDisable = false;
                    });
                }
            },

            //验证码认证
            checkCaptcha() {
                if (!this.forgetPasswordForm.verifyCode) {
                    this.toast("请输入验证码");
                    return;
                }
                this.btnDisable = true;
                this.$store.dispatch('VerifyCode', this.forgetPasswordForm)
                    .then((response) => {
                    if (this.$API_CODE.OK === response.code) {
                        this.showSettingPassword = true
                    }
                    this.btnDisable = false;
                }).catch(error=>{
                    this.message = error.message;
                    this.messageVisible = true;
                    this.btnDisable = false;
                })
            },

            //重设密码
            resetPassword() {
                let password = '';
                let confirmPassword = '';
                if (this.forgetPasswordForm.password.trim() !== '') {
                    password = md5(this.forgetPasswordForm.password).substr(8, 16);
                }
                if (this.forgetPasswordForm.confirmPassword.trim() !== '') {
                    confirmPassword = md5(this.forgetPasswordForm.confirmPassword).substr(8, 16);
                }

                ResetPassword(password, confirmPassword).then((response) => {
                    if (this.$API_CODE.OK === response.code) {
                        this.toast("密码修改成功");
                        this.isEdit = true;
                    } else {
                        this.messageVisible = true;
                        this.message = response.message;
                    }
                })
            },

            searchOrder(memberId) {
                SearchOrder(memberId).then((response) => {
                    if (this.$API_CODE.OK === response.code) {
                        this.forgetPasswordForm.mobile = response.data.mobile
                    } else {
                        this.messageVisible = true;
                        this.message = response.message;
                    }
                })
            },

            callPhone() {
                window.location.href = 'tel://' + PASSWORD_MOBILE;
            },

            //限制输入框的内容只能为汉字
            inputChange(e) {
                const o = e.target;
                if (o.value.length >=4 ) {
                    this.sendDisable = true;
                } else {
                    this.sendDisable = false;
                }

            },
        }
    }
</script>

<style lang="scss" scoped>

    .bg-icon {
        margin: 30px;
        img {
            width: 180px;
            height: 180px;
        }
    }
    #forget-password-form-info {
        margin-left: 30px;
        margin-right: 30px;
        margin-top: 30px;

        .info {
            width: 80%;
            height: 40px;
            margin-top: 10px;
            border-radius: 5px;
            border: 2px solid #ed3f14;
            display: flex;
            align-items: center;
            float: left;

            .input {
                height: 25px;
                border: 0;
                outline: none;
                margin-left: 1rem;
                background: #fdf9f7;
                font-size: 0.9rem;
                width: 100%;
            }

            .icon {
                width: 16px;
                height: 16px;
                float: left;
                margin-left: 20px;
            }
        }

        .search-member {
            float: right;
            width: 17%;
            /*height: 40px;*/
            margin-top: 10px;
            background-color: #ed3f14;
            color: white;
            line-height: 28px;
            border-radius: 5px;
            font-size: 1rem;
            border: 0;
        }

        /*.search-member {*/
            /*background-color: #BDBDBD;*/
        /*}*/

        .rest {
            background-color: #757575;
        }

        #input-password {
            margin-top: 30px;
            .password {
                width: 100%;
                height: 40px;
                border-radius: 5px;
                margin-top: 10px;
                border: 2px solid #ed3f14;
                display: flex;
                align-items: center;
                float: left;

                .input {
                    height: 25px;
                    border: 0;
                    outline: none;
                    margin-left: 1rem;
                    background: #fdf9f7;
                    font-size: 0.9rem;
                    width: 100%;
                }
            }
        }
    }

    #forget-password-member-submit {
        margin-left: 30px;
        margin-right: 30px;

        .submit-btn {
            width: 100%;
            height: 40px;
            margin-top: 10px;
            line-height: 40px;
            border: 0;
            border-radius: 5px;
            background-color: #ed3f14;
            color: white;
            font-size: 1rem;
        }
    }
</style>